var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "Main",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,5H15V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V17a2,2,0,0,0,2,2H9v1a2,2,0,0,0,2,2h9a2,2,0,0,0,2-2V7A2,2,0,0,0,20,5ZM4,17V4h9V5H11A2,2,0,0,0,9,7H6A1,1,0,0,0,6,9H9v1H6a1,1,0,0,0,0,2H9v1H6a1,1,0,0,0,0,2H9v2Zm7,3V7h9V20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.58,8.19a1,1,0,0,0-1.39.23L15.5,10.78,13.81,8.42a1,1,0,1,0-1.62,1.16l2.08,2.92-2.08,2.92a1,1,0,0,0,.23,1.39A1,1,0,0,0,13,17a1,1,0,0,0,.81-.42l1.69-2.36,1.69,2.36A1,1,0,0,0,18,17a1,1,0,0,0,.58-.19,1,1,0,0,0,.23-1.39L16.73,12.5l2.08-2.92A1,1,0,0,0,18.58,8.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/Decline.84986143ef2c0c0baf4579a9d5a0160e.svg";
export { ForwardRef as ReactComponent };